// @flow

import type { DateString } from './date-string'
import uuidv4 from 'uuid/v4'

export type OrderItem = {
  id: ?string,
  productConfigurationCode: ?string,
  startDate: ?DateString,
  engravedId: ?string,
  payInTerms: ?boolean,
  nrOfTerms: ?number,
  title: string,
  renewSubscriptionId: ?string,
  receiveSubscriptionReminders: boolean
}

const buildOrderItem = function (): OrderItem {
  return {
    id: uuidv4(),
    productConfigurationCode: null,
    startDate: null,
    engravedId: null,
    payInTerms: null,
    nrOfTerms: null,
    title: '',
    renewSubscriptionId: null,
    receiveSubscriptionReminders: false
  }
}

export {
  buildOrderItem
}



// WEBPACK FOOTER //
// ./src/types/order-item.js